export default __webpack_public_path__ + "static/media/client-12.06ff10d1.png";